import React, {useState} from 'react';
import PropTypes from 'prop-types';


import * as styleUtils from '../../../utils/styleUtils';

import {authConstants, useIsAuthenticated} from '../../contexts/Auth';
import {buyConstants} from '../../modules/Buy';
import {registrationConstants} from '../../modules/Registration';
import {staticConstants} from '../../modules/Static';

import CartLink from './CartLink';
import NavItem from './NavItem';

import styles from './MainNavigation.scss';



function MainNavigation({children}) {

    const [isHamburgerMenuActive, setIsHamburgerMenuActive] = useState(false);
    const isAuthenticated = useIsAuthenticated();

    return (
        <div
            className={
                styleUtils.toClasses(
                    styles.mainNavigation,
                    isHamburgerMenuActive
                        ? 'hamburger-mode'
                        : null,
                    'col-12'
                )
            }
        >

            <div
                className={styles.hamburgerMenu}
                onClick={() => setIsHamburgerMenuActive(!isHamburgerMenuActive)}
            />

            <ul className={isHamburgerMenuActive ? 'hamburger-mode' : ''}>

                {isAuthenticated && (
                    <>
                        <NavItem
                            labelI18n={'main.nav.buy.label'}
                            path={buyConstants.NAV_BUY_OVERVIEW_PAGE}
                            requiredRole={authConstants.ROLE_FEATURE_SEARCH}
                        />

                        <CartLink/>
                    </>
                )}

                {!isAuthenticated && (
                        <>
                            <NavItem
                                isExact={true}
                                labelI18n={'main.nav.home.label'}
                                path={staticConstants.NAV_HOME}
                            />

                            <NavItem
                                labelI18n={'main.nav.register.label'}
                                path={registrationConstants.NAV_REGISTRATION_BASE}
                            />

                            <NavItem
                                labelI18n={'main.nav.login.label'}
                                path={authConstants.NAV_LOGIN}
                            />
                        </>
                )}

                {children}

            </ul>
        </div>
    );
}


MainNavigation.propTypes = {
    children: PropTypes.any
};


export default MainNavigation;
